import { render } from "./vehiclesHistory.vue?vue&type=template&id=093ae806&scoped=true"
import script from "./vehiclesHistory.vue?vue&type=script&lang=js"
export * from "./vehiclesHistory.vue?vue&type=script&lang=js"

import "./vehiclesHistory.vue?vue&type=style&index=0&id=093ae806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093ae806"]])

export default __exports__